module.exports = __webpack_public_path__ + "img/saishianpai-title-icon.6d19c87e.png";